import { ReactComponent as DocumentIcon } from '@/assets/images/icons/files/document.svg'
import { ReactComponent as ImageIcon } from '@/assets/images/icons/files/image.svg'
import { ReactComponent as PdfIcon } from '@/assets/images/icons/files/pdf.svg'
import { ReactComponent as SignatureIcon } from '@/assets/images/icons/files/signature.svg'

export const iconTypes = [
  {
    color: '#8BC8EF',
    extensions: ['xlsx', 'doc', 'docx', 'txt'],
    icon: DocumentIcon,
  },
  {
    color: '#8ADAC8',
    extensions: ['signature'],
    icon: SignatureIcon,
  },

  {
    color: '#EF8B8B',
    extensions: ['pdf'],
    icon: PdfIcon,
  },
  {
    color: '#EF8BD2',
    extensions: ['jpg', 'jpeg', 'png', 'svg', 'gif'],
    icon: ImageIcon,
  },
]
